import { render, staticRenderFns } from "./CompMenu.vue?vue&type=template&id=644fbd8d&"
import script from "./CompMenu.vue?vue&type=script&lang=js&"
export * from "./CompMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports